import {
    SERVICE_CREATED,
    SERVICE_ERROR,
    DELETE_SERVICE,
    SERVICE_UPDATED,
    SERVICE_LIST_UPDATED,
    GET_SERVICE_BY_ID,
    LOADING_ON_SERVICE_SUBMIT,
    SERVICE_SEARCH_PARAMATERS_UPDATE,
    CHANGE_SERVICE_STATUS,
    LOAD_PAGE,
    LOADING_SERVICE_LIST_DATA,
    RESET,
  } from "actions/types";
  import * as Constants from "constants/index";
  
  const initialState = {
    serviceList: {
      page: 1,
      data: [],
      count: 0,
    },
    currentService: [],
    loadingServiceList: true,
    loadingService: true,
    loadingListData: true,
    performDelete: false,
    error: {},
    sortingParams: {
      limit: Constants.DEFAULT_PAGE_SIZE,
      page: 1,
      orderBy: "created_at",
      ascending: "desc",
      query: "",
    },
  };
  
  export default function Index(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case RESET:
        return {
          ...initialState,
          loadingService: state.loadingService,
          loadingServiceList: state.loadingServiceList,
          loadingListData: state.loadingListData,
        };
      case LOAD_PAGE:
        return {
          ...state,
          loadingService: false,
        };
      case SERVICE_CREATED:
        return {
          ...state,
          loadingService: false,
        };
      case SERVICE_UPDATED:
        return {
          ...state,
          currentService: payload,
          sortingParams: initialState.sortingParams,
          loadingService: false,
        };
      case SERVICE_ERROR:
        return {
          ...state,
          error: payload,
          loadingService: false,
          loadingServiceList: false,
          loadingListData: false,
          performDelete: false,
        };
      case DELETE_SERVICE:
        const currentCount = state.serviceList.count;
        const currentLimit = state.sortingParams.limit;
        const currentPage = parseInt(state.serviceList.page);
        let remainingPages = Math.ceil((currentCount - 1) / currentLimit);
        remainingPages = remainingPages ? remainingPages : 1;
        return {
          ...state,
          serviceList: {
            data: state.serviceList.data.filter(
              (service) => service._id !== payload
            ),
            count: currentCount - 1,
            page:
              currentPage <= remainingPages
                ? currentPage.toString()
                : remainingPages.toString(),
          },
          loadingServiceList: false,
          performDelete: true,
        };
      case GET_SERVICE_BY_ID:
        return {
          ...state,
          currentService: payload,
          loadingService: false,
        };
      case SERVICE_LIST_UPDATED:
        return {
          ...state,
          serviceList: {
            data: payload.data,
            page: payload.metadata[0].current_page,
            count: payload.metadata[0].totalRecord,
          },
          // loadingService: true,
          loadingServiceList: false,
          loadingListData: false,
          performDelete: false,
        };
      case SERVICE_SEARCH_PARAMATERS_UPDATE:
        return {
          ...state,
          sortingParams: { ...payload },
        };
  
      case CHANGE_SERVICE_STATUS:
        return {
          ...state,
          serviceList: {
            ...state.serviceList,
            data: state.serviceList.data.map((service) =>
              service._id === payload._id
                ? { ...service, status: payload.status }
                : service
            ),
          },
        };
      case LOADING_SERVICE_LIST_DATA:
        return {
          ...state,
          loadingListData: true,
        };
      case LOADING_ON_SERVICE_SUBMIT:
        return {
          ...state,
          loadingService: true,
        };
  
      default:
        return state;
    }
  }
  